<template>
  <div class="continer">
    <div class="header">
      <!-- 返回 -->
      <div class="back" @click="goBack()">
        <img src="@/assets/images/daily_task/close.png" alt="" srcset="" />
      </div>
      <!-- 标题 -->
      <div class="title">获奖记录</div>
    </div>
    <div class="main" v-if="pageData.length">
      <div class="table-headr">
        <div class="item">任务名称</div>
        <div class="item">领奖时间</div>
        <div class="item">奖励金额</div>
      </div>
      <div class="table-body">
        <div class="item" v-for="(item, index) in pageData" :key="index">
          <div class="item-name">{{ item.ad_title }}</div>
          <div class="item-time">{{ item.time }}</div>
          <div class="item-amount">{{ item.amount }}元</div>
        </div>
      </div>
    </div>
    <div v-else class="empty">
      <div class="inner">
        <img src="@/assets/images/recharge_task/empty.png" alt="" srcset="" />
        <div>
          <p>您还没有获奖记录</p>
          <p>继续努力吧</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { Toast, Empty, PullRefresh, Popup } from 'vant'

Vue.use(Toast)
  .use(Empty)
  .use(Popup)
  .use(PullRefresh)
export default {
  data() {
    return {
      // 剩余时间
      pageData: [],
      // 参数
      appId: '',
      userId: '',
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      // 初始化参数
      this.appId = this.$route.query.app_id
      this.userId = this.$route.query.user_id
      // 获取数据
      this.getPageData()
    },
    callClienFunc: function(fname, fval) {
      if (window.hasOwnProperty('injectedObject')) {
        window.injectedObject.setJsContent(fname, fval)
      } else {
        fval = fval ? fval : {}
        let params = { method: fname, params: fval }
        params = JSON.stringify(params)
        window.Android.postMessage(params)
      }
    },
    goBack() {
      this.$router.go(-1)
    },
    getPageData() {
      const params = {
        app_id: this.appId,
        userid: this.userId,
      }

      console.log(params)
      return new Promise((resolve, reject) => {
        Toast.loading({
          message: '加载中...',
          forbidClick: true,
          loadingType: 'spinner',
        })
        this.$http
          .get(
            'https://adv.bugmake.com/api/cpl/get_daily_recharge_task_complete_record',
            {
              params,
            }
          )
          .then((res) => {
            console.log(res)
            if (res.code != 1) {
              return reject()
            }
            this.pageData = res.data.list ? res.data.list : []
            resolve()
          })
          .catch((err) => {
            console.log(err)
            reject()
          })
          .finally(() => {
            Toast.clear()
          })
      })
    },
  },
}
</script>

<style lang="less" scoped>
.continer {
  max-width: inherit;
  font-family: PingFangSC-Medium;
  position: relative;
  min-height: 100vh;
}

.header {
  display: flex;
  align-items: center;
  height: 0.44rem;
  padding-top: 0.3rem;
  position: relative;

  .back {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 0.44rem;
    height: 0.33rem;
    position: absolute;
    top: 0.3rem;
    left: 0;
    z-index: 999;

    img {
      width: 0.14rem;
    }
  }

  .title {
    flex: 1;
    display: flex;
    justify-content: center;
    font-size: 0.16rem;
    color: #333333;
    letter-spacing: 0;
    text-align: center;
    line-height: 0.18rem;
    font-weight: 500;
  }
}

.main {
  .table-headr {
    position: sticky;
    top: 0;
    display: flex;
    align-items: center;
    height: 0.4rem;
    background: #fafafa;
    padding: 0 0.16rem;

    .item {
      flex: 1;
      font-size: 0.14rem;
      color: #666666;
      text-align: center;
      line-height: 0.16rem;

      &:first-child {
        text-align: start;
      }

      &:last-child {
        text-align: end;
      }
    }
  }

  .table-body {
    margin: 0 0.16rem;

    .item {
      display: flex;
      align-items: center;
      height: 0.4rem;
      border-bottom: 0.01rem solid #fafafa;

      div {
        flex: 1;
        font-size: 0.14rem;
        color: #333333;
        text-align: center;
        line-height: 0.16rem;
      }

      .item-name {
        text-align: start;
        // 超出省略
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      .item-amount {
        text-align: end;
        font-weight: 600;
      }
    }
  }
}
.empty {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  .inner {
    display: flex;
    flex-direction: column;
    align-items: center;

    img {
      width: 0.88rem;
    }

    p {
      font-size: 0.12rem;
      color: #999999;
      text-align: center;
    }
  }
}
</style>
